const downloadReportsToast = (state = null, action) => {
  if (action.type === "SET_DOWNLOAD_REPORT_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_DOWNLOAD_REPORT_TOAST": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default downloadReportsToast;
